// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btn-outline-secondary[data-v-76281962]{color:#75767e;border-color:#75767e}.btn-outline-secondary[data-v-76281962]:hover{color:#fff;background-color:#6c757d;border-color:#6c757d}.card__post[data-v-76281962]{width:100%}.card__post .post__date[data-v-76281962]{color:rgba(7,9,25,.5)}.card__post .carousel__post-item[data-v-76281962]{width:100%;max-width:680x;height:300px}", ""]);
// Exports
module.exports = exports;
